import { Component } from '@angular/core';
import { LoadingService } from '../../services/util/loading.service';

@Component({
  selector: 'app-layout',
  templateUrl: './auth-layout.component.html'
})
export class AuthLayoutComponent {
  constructor(private loadingService: LoadingService) {
  }

  activePageSpinner() {
    return this.loadingService.mustShowPageSpinner();
  }
}
